import { Caption } from 'canoe';
import React from 'react';

interface Props {
  currentStep: number;
  withSnapshots?: boolean;
}

export const Stepper = ({ currentStep, withSnapshots = true }: Props) => (
  <Caption textAlign="center" color="OnyxGrayL30" maxWidth="none">
    STEP {currentStep} OF {withSnapshots ? '4' : '2'}
  </Caption>
);
